export enum RegisterResult {
  Success = 'success',
  Failed = 'failed'
}
